class Messenger {
  constructor() {
    this.production = process.env.NODE_ENV === 'production';
    this.client = this.getClient(window.jwtSecret);
  }

  _buildSocketURL() {
    let port = `:${window.websocketPort || 9292}`;

    if (this.production) {
      port = location.port ? `:${location.port}` : '';
    }

    return `${location.protocol}//${location.hostname}${port}`;
  }

  getClient(token) {
    const socket_path = window.websocketPath || '/socket';
    const options = {
      path: socket_path + '/socket.io',
      query: `token=${token}`,
    };

    if (typeof io === 'undefined') {
      return console.warn('Websocket is not available') || false;
    } // eslint-disable-line no-console
    return io(this._buildSocketURL(), options);
  }

  on(channel, callback) {
    if (!this.client) {
      return;
    }

    console.log('Listening at channel ' + channel); // eslint-disable-line no-console
    this.client.on(channel, callback);
    return callback;
  }

  off(channel, subscription) {
    if (!this.client) {
      return;
    }

    if (typeof subscription === 'undefined') {
      throw new Error('You need to specify a subscription');
    }
    console.log('Stopped listening at channel ' + channel); // eslint-disable-line no-console
    this.client.off(channel, subscription);
  }

  unsubscribe(channel) {
    if (!this.client) {
      return;
    }

    this.client.off(channel);
  }
}

module.exports = new Messenger();
